import { AnnotationPlugin } from '@st/document-viewer-kit'
import { StampAnnotation } from '@st/sdk'
import { CheckmarkToolState } from '~/st-doc-viewer/annotations'
import { CheckmarkAnnotationElement, CheckmarkToolOverlay } from './ui'
import { CHECKMARK_TICK_STAMP } from '../stamp/templates'
import { syncToolStateWithAnnotation } from './tool-state'

export { CheckmarkToolEditor } from './ui'

export function checkmarkPlugin(): AnnotationPlugin<StampAnnotation, CheckmarkToolState> {
  return {
    name: 'checkmark',
    initialToolState: {
      name: 'checkmark',
      settings: {
        templateId: CHECKMARK_TICK_STAMP.id,
        color: CHECKMARK_TICK_STAMP.annotation.color,
        stampSize: CHECKMARK_TICK_STAMP.annotation.stampSize
      }
    },
    ToolOverlay: CheckmarkToolOverlay,
    Element: CheckmarkAnnotationElement,
    handlesAnnotation: (annotation) => {
      if (annotation.type !== 'stamp') return false
      const stamp = annotation as StampAnnotation
      return stamp.stampType === 'tick_mark' && stamp.text === '✓'
    },
    onAnnotationSelected: (event) => {
      const annotation = event.annotationDraft ?? event.annotation
      if (annotation) {
        return {
          type: 'updateTool',
          tool: syncToolStateWithAnnotation(annotation as StampAnnotation)
        }
      }
      return null
    },
    onAnnotationDeselected: (event) => {
      if (event.annotationDraft)
        return { type: 'commitAnnotationDraft', annotationDraft: event.annotationDraft }
      return null
    }
  }
}
